import { gql } from '@apollo/client';

import {
  AddRecordingEventDocument,
  type AddRecordingEventMutation,
  type AddRecordingEventMutationVariables,
} from '../__generated__/documents';

if (false) {
  gql`
    mutation AddRecordingEvent($input: AddRecordingEventInput!) {
      addRecordingEvent(input: $input) {
        id
        time
        type
        messageId
      }
    }
  `;
}

export const ADD_RECORDING_EVENT = AddRecordingEventDocument;
export type { AddRecordingEventMutation, AddRecordingEventMutationVariables };
